<script>
import TableBlock from '@/components/Analysis/TableBlockMixin';
export default {
  mixins: [TableBlock],

  computed: {
    computedData() {
      const { sites, filteredCollaborators } = this.data;
      const computedSites = this.range ? sites.slice(this.range[0], this.range[1]) : sites;
      const accessTimesHeaderSpecs = ['20 - 25 min', '25 - 30 min', '+ 30 min'].map(caption => {
        return {
          type: 'heading',
          caption,
          icon: 'up',
        };
      });
      let entries = this.comuputesensibleCaseDecay(computedSites).map((row, idx) => {
        const site = computedSites[idx];
        row.unshift(this.buildSiteBlock(site, filteredCollaborators, this.forcedTransport));
        row.push({
          value: site.details.impact.sensibleCaseDecay.averageTime,
          sub: ' min',
        });
        return row;
      });
      const accessTimes = computedSites.map(site => {
        const { sensibleCaseCollaboratorsByTimeDiffRanges } = site.details;
        return sensibleCaseCollaboratorsByTimeDiffRanges.map(item => {
          return {
            value: item.count,
            icon: 'people',
          };
        });
      });
      entries = entries.map((item, idx) => {
        return [
          ...item,
          ...accessTimes[idx],
          {
            type: 'ui-block',
            components:
              accessTimes[idx].reduce((acc, value) => acc + value.value, 0) > 0
                ? [
                    {
                      icon: 'closethin',
                      action: () => this.openOutlierDetail(item[0].id),
                    },
                  ]
                : [],
          },
        ];
      });
      return {
        data: {
          specifications: [
            {
              className: {
                big: true,
              },
            },
            {
              type: 'heading',
              caption: this.$t('outlierNumber'),
            },
            {
              type: 'heading',
              caption: this.$t('averageAccessTime'),
            },
            ...accessTimesHeaderSpecs,
            {
              className: {
                ui: true,
              },
            },
          ],
          entries,
        },
      };
    },
  },

  methods: {
    openOutlierDetail(id) {
      this.$store.dispatch('updateCurrentModal', {
        component: 'OutlierDetail',
        params: {
          id,
        },
      });
    },
  },
};
</script>
